const formatValue = (value) => {
  if (Array.isArray(value)) {
    return JSON.stringify(value);
  }
  return String(value);
};

export default formatValue;
